module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Regular.70bf797.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Regular.ttf
// module id = uf1r
// module chunks = 1